import { Link } from "@inertiajs/react";
import Callout from "@/components/help/Callout";
import Screenshot from "@/components/help/Screenshot";
import LogMinutesCard from "@/components/schools/LogMinutesCard";
import { STUDENTS_FOR_LOG } from "@/help/fixtures";

export default function LoggingClassroomMinutes() {
  return (
    <>
      <p>
        Logging reading time for your class takes a few seconds. Pick how long the class read, uncheck anyone who was away, and submit. Every student starts checked.
      </p>

      <h2>Where it is</h2>
      <p>
        On your classroom dashboard, tap <strong>Log minutes</strong> in the card at the top. It's there whenever minute logging is open.
      </p>

      <Screenshot caption="The log-minutes form">
        <LogMinutesCard students={STUDENTS_FOR_LOG} initialMinutes="20" initialNote="Charlotte's Web · ch 3" initialAllChecked={false} />
      </Screenshot>

      <h2>What to fill in</h2>
      <p>
        Tap 15, 20, 30 or 45 minutes, or type the time yourself (anything from 1 minute to a full day). Tap anyone who was away to uncheck them — anywhere on their row works. Add a note if you'd like, with what you read or where you stopped; families see it on their child's reading list. The button shows how many students you're logging for, so you can double-check before you submit.
      </p>

      <Callout variant="tip" title="Log right after reading time">
        <p>
          It's easier to remember who was there at the end of the period. Add your dashboard to your phone's home screen and it's one tap away.
        </p>
      </Callout>

      <h2>What happens after you submit</h2>
      <p>
        Each student's minutes go up, your class totals update everywhere, and the log appears in your recent activity with <strong>Edit</strong> and <strong>Undo</strong> buttons in case you need to fix it. If a student reached a prize, they show up in your prize tracker too.
      </p>

      <h2>A few common questions</h2>
      <p>
        <strong>Logged the wrong number?</strong> Tap <strong>Edit</strong> on it in your recent activity, or undo it and log again — see <Link href="/help/articles/undoing-minute-batches">Undoing a reading log</Link>.
      </p>
      <p>
        <strong>One student needs different minutes than the rest?</strong> Open that student's page and log for them on their own — see <Link href="/help/articles/logging-solo-minutes">Logging for one student</Link>.
      </p>
      <p>
        <strong>Logging for yesterday?</strong> Logs are stamped with the current time. If the day matters (Friday's reading logged on Monday), say so in the note.
      </p>
      <p>
        <strong>Don't see the button?</strong> Reading hasn't started yet, or logging has closed. Minutes can be logged from the start date until logging closes (by default 9:00 AM the morning after the last day of reading); the dashboard says which.
      </p>

      <h2>What's next</h2>
      <ul>
        <li><Link href="/help/articles/logging-solo-minutes">Logging for one student</Link>.</li>
        <li><Link href="/help/articles/undoing-minute-batches">Undoing a reading log</Link>.</li>
      </ul>
    </>
  );
}
